import { PDFDocument, PDFImage, PDFPage } from 'pdf-lib';

export const embedSignatureImage = async (pdfDoc: PDFDocument, dataUrl: string) => {
  try {
    return await pdfDoc.embedPng(dataUrl);
  } catch {
    throw new Error('Signature could not be processed. Please clear the signature and sign again.');
  }
};

export const drawSignatureImage = (
  page: PDFPage,
  image: PDFImage,
  placement: { x: number; y: number; height?: number; width?: number; opacity?: number },
  maxWidth = 180,
): void => {
  const boxWidth = placement.width ?? maxWidth;
  const boxHeight = placement.height ?? image.height;
  const scale = Math.min(boxWidth / image.width, boxHeight / image.height, 1);
  page.drawImage(image, {
    x: placement.x,
    y: placement.y,
    width: image.width * scale,
    height: image.height * scale,
    opacity: placement.opacity,
  });
};
